import { createAction, props } from '@ngrx/store';

import { Label } from '../../classes/label';
import { PremiitError } from '../../utils/premiit-error';

export const getLabelsAction = createAction('[Labels] getting labels');

export const getLabelsSuccessAction = createAction(
  '[Labels] getting labels successfully',
  props<{ labels: Label[] }>()
);

export const getLabelsErrorAction = createAction(
  '[Labels] getting labels error',
  props<{ error: PremiitError }>()
);

export const selectLabel = createAction('[Labels] Select label', props<{ label: Label }>());

export const unSelectLabel = createAction('[Labels] Unselect label');

export const setLabelColor = createAction('[Labels] set color', props<{ color: string }>());

export const createLabelAction = createAction(
  '[Labels] create label action',
  props<{ label: Label }>()
);

export const createLabelSuccessAction = createAction(
  '[Labels] create label successfully',
  props<{ label: Label }>()
);

export const createLabelErrorAction = createAction(
  '[Labels] create label error',
  props<{ error: PremiitError }>()
);

export const deleteLabelAction = createAction('[Labels] Delete label', props<{ label: Label }>());

export const deleteLabelSuccessAction = createAction(
  '[Labels] delete labels successfully',
  props<{ label: Label }>()
);

export const deleteLabelError = createAction(
  '[Labels] delete labels error',
  props<{ error: PremiitError }>()
);

export const updateLabelAction = createAction(
  '[Labels] update label',
  props<{ label: Label }>()
);

export const updateLabelSuccessAction = createAction(
  '[Labels] update label successfully',
  props<{ label: Label }>()
);

export const updateLabelErrorAction = createAction(
  '[Labels] update label error',
  props<{ error: PremiitError }>()
);
